const {contentTypes} = require('./contentTypes');
const hubTypes = {
	REGION: 1,
	HEALTHCARE: 2,
	THOUGHT_LEADERSHIP: 3,
	LIVE_EVENT: 4,
	PHARMA: 5,
	MED_TECH: 6,
	CRITICAL_ISSUES: 7,
	MANAGEMENT: 8,
	GLOBAL: 9,
	CONSUMER: 10,
	MED_TECH_SUB: 11,
	PHARMA_SUB: 12,
};

const specialHubs = {
	ASIA_PACIFIC: {
		Slug: 'asia-pacific',
		ID: 10,
		TypeID: hubTypes.REGION,
	},
	AMERICAS: {
		Slug: 'americas',
		ID: 11,
		TypeID: hubTypes.REGION,
	},
	MIDDLE_EAST_AND_NORTH_AFRICA: {
		Slug: 'middle-east-and-north-africa',
		ID: 12,
		TypeID: hubTypes.REGION,
	},
	SUB_SAHARAN_AFRICA: {
		Slug: 'sub-saharan-africa',
		ID: 4,
		TypeID: hubTypes.REGION,
	},
	WESTERN_EUROPE: {
		Slug: 'western-europe',
		ID: 13,
		TypeID: hubTypes.REGION,
	},
	CENTRAL_AND_EASTERN_EUROPE: {
		Slug: 'central-and-eastern-europe',
		ID: 14,
		TypeID: hubTypes.REGION,
	},
	LIVE_EVENT: {
		Slug: 'live-event',
		ID: 17,
		TypeID: hubTypes.LIVE_EVENT,
		ContentTypeID: contentTypes.LIVE_EVENT,
	},
	PHARMA: {
		Slug: 'pharma',
		ID: 33,
		TypeID: hubTypes.PHARMA,
		ProductIDs: [6, 8],
	},
	MED_TECH: {
		Slug: 'med-tech',
		ID: 34,
		TypeID: hubTypes.MED_TECH,
		ProductIDs: [7, 9],
	},
	EMERGING_COMPETITIVE_RISKS: {
		Slug: 'emerging-competitive-risks',
		ID: 53,
		TypeID: hubTypes.CRITICAL_ISSUES,
	},
	EVENTS_TO_WATCH: {
		Slug: 'events-to-watch-for-2026',
		ID: 24,
		TypeID: hubTypes.CRITICAL_ISSUES,
	},
	LATIN_AMERICA: {
		Slug: 'latin-america-nearshoring-hub',
		ID: 31,
		TypeID: hubTypes.CRITICAL_ISSUES,
	},
	MENA_GEOPOLITICAL: {
		Slug: 'mena-geopolitical-risk',
		ID: 30,
		TypeID: hubTypes.CRITICAL_ISSUES,
	},
	RUSSIA_UKRAINE: {
		Slug: 'russia-ukraine-war',
		ID: 26,
		TypeID: hubTypes.CRITICAL_ISSUES,
	},
	TRUMP_TARIFFS: {
		Slug: 'trump-tariffs-tracker',
		ID: 36,
		TypeID: hubTypes.CRITICAL_ISSUES,
	},
	US_CHINA: {
		Slug: 'us-china-tensions',
		ID: 9,
		TypeID: hubTypes.CRITICAL_ISSUES,
	},
	EXECUTIVE_SENTIMENT: {
		Slug: 'executive-sentiment',
		ID: 56,
		TypeID: hubTypes.MANAGEMENT,
	},
	MANAGEMENT_BEST_PRACTICES: {
		Slug: 'management-best-practices',
		ID: 54,
		TypeID: hubTypes.MANAGEMENT,
	},
	CHANNEL_MANAGEMENT: {
		Slug: 'channel-management',
		ID: 23,
		TypeID: hubTypes.MANAGEMENT,
	},
	THOUGHT_LEADERSHIP_HUB: {
		Slug: 'thought-leadership',
		ID: 6,
		TypeID: hubTypes.MANAGEMENT,
	},
	GLOBAL_INSIGHTS: {
		Slug: 'global-insights',
		ID: 27,
		TypeID: hubTypes.GLOBAL,
	},
	COMMODITIES: {
		Slug: 'commodities-view',
		ID: 29,
		TypeID: hubTypes.GLOBAL,
	},
	FX_TRACKERS: {
		Slug: 'fx-trackers',
		ID: 35,
		TypeID: hubTypes.GLOBAL,
	},
	CONSUMER_LANDSCAPE: {
		Slug: 'consumer-landscape',
		ID: 41,
		TypeID: hubTypes.CONSUMER,
	},
	FOOD_BEVERAGE: {
		Slug: 'food-and-beverage',
		ID: 38,
		TypeID: hubTypes.CONSUMER,
	},
	ALCOHOLIC_BEVERAGES: {
		Slug: 'alcoholic-beverages',
		ID: 39,
		TypeID: hubTypes.CONSUMER,
	},
	PERSONAL_CARE: {
		Slug: 'personal-care',
		ID: 40,
		TypeID: hubTypes.CONSUMER,
	},
	OTHER_CONSUMER_GOODS: {
		Slug: 'other-consumer-goods-sectors',
		ID: 42,
		TypeID: hubTypes.CONSUMER,
	},
	MED_TECH_COMMERCIAL_PLANNING: {
		Slug: 'commercial-planning-and-execution',
		ID: 47,
		TypeID: hubTypes.MED_TECH_SUB,
	},
	MED_TECH_MARKET_ACCESS: {
		Slug: 'market-access-and-reimbursement',
		ID: 49,
		TypeID: hubTypes.MED_TECH_SUB,
	},
	MED_TECH_POLICY: {
		Slug: 'policy-government-affairs',
		ID: 52,
		TypeID: hubTypes.MED_TECH_SUB,
	},
	PHARMA_COMMERCIAL_PLANNING: {
		Slug: 'commercial-planning-and-execution',
		ID: 48,
		TypeID: hubTypes.PHARMA_SUB,
	},
	PHARMA_MARKET_ACCESS: {
		Slug: 'market-access-and-reimbursement',
		ID: 50,
		TypeID: hubTypes.PHARMA_SUB,
	},
	PHARMA_POLICY: {
		Slug: 'policy-and-government-affairs',
		ID: 51,
		TypeID: hubTypes.PHARMA_SUB,
	},
};

const specialHubNames = Object.keys(specialHubs);
const specialHubMap = {};
for (let x = 0; x < specialHubNames.length; x++) {
	specialHubMap[specialHubs[specialHubNames[x]].ID] = specialHubs[specialHubNames[x]];
}

module.exports = {
	hubTypes,
	specialHubs,
	specialHubMap,
};
